module.exports = __webpack_public_path__ + "img/ed-light.48faa55.png";